import React, { useEffect, useState } from "react";
import { listInvoices } from "../../services/cateringInvoiceService";
import { Link, useNavigate } from "react-router-dom";

const InvoiceList = () => {
  const [invoices, setInvoices] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    listInvoices()
      .then(setInvoices)
      .catch(err => console.error("Failed to fetch invoices", err.message));
  }, []);

  const filteredInvoices = invoices.filter(inv => {
    const name = inv.CateringCustomer?.name?.toLowerCase() || "";
    const mobile = inv.CateringCustomer?.mobile || "";
    const query = searchQuery.toLowerCase();
    return name.includes(query) || mobile.includes(query);
  });

  return (
    <div className="p-4 max-w-2xl mx-auto text-gray-800 relative">
      <h2 className="text-3xl font-bold mb-6 text-center text-blue-700">🧾 Catering Invoices</h2>

      {/* 🔍 Search Input */}
      <div className="mb-4">
        <input
          type="text"
          placeholder="Search by name or mobile..."
          className="w-full px-4 py-2 border rounded shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-300"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
      </div>

      {filteredInvoices.length === 0 ? (
        <div className="text-center text-gray-400 mt-10">No invoices found</div>
      ) : (
        <div className="space-y-4">
          {filteredInvoices.map((inv, idx) => {
            const isPaidFully = inv.paidAmount >= inv.budget;

            return (
              <div key={inv.id} className="bg-gradient-to-br from-blue-50 to-white shadow-md rounded-xl p-4 border border-gray-100">
                <div className="flex justify-between items-center">
                  <div className="text-base font-semibold text-gray-800">{inv.CateringCustomer?.name || "Unnamed"}</div>
                  <div className="text-sm text-gray-500">#{idx + 1}</div>
                </div>

                <div className="mt-1 text-sm text-gray-600">📞 {inv.CateringCustomer?.mobile || "N/A"}</div>
                <div className="text-sm text-gray-600">📅 {inv.eventDate}</div>

                <div className="mt-3 grid grid-cols-2 gap-2 text-sm">
                  <div className="bg-gray-100 px-3 py-2 rounded">
                    <div className="text-xs text-gray-500">Budget</div>
                    <div className="font-semibold text-green-700">₹{inv.budget}</div>
                  </div>
                  <div className={`px-3 py-2 rounded ${isPaidFully ? 'bg-green-100' : 'bg-yellow-100'}`}>
                    <div className="text-xs text-gray-500">Paid</div>
                    <div className={`font-semibold ${isPaidFully ? 'text-green-800' : 'text-yellow-800'}`}>
                      ₹{inv.paidAmount}
                    </div>
                  </div>
                </div>

                <div className="mt-4 text-right">
                  <Link
                    to={`/invoices/${inv.id}`}
                    className="bg-blue-600 hover:bg-blue-700 text-white px-5 py-1.5 rounded-full text-sm shadow-md transition-all"
                  >
                    View Details
                  </Link>
                </div>
              </div>
            );
          })}
        </div>
      )}

      {/* 🟢 Floating Add Button */}
      <button
        onClick={() => navigate("/catering-invoice/create")}
        className="fixed bottom-14 right-2 bg-blue-600 hover:bg-blue-700 text-white text-xl w-14 h-14 rounded-full shadow-lg flex items-center justify-center transition-all"
        title="Create Catering Invoice"
      >
        +
      </button>
    </div>
  );
};

export default InvoiceList;
